import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { heroData, infoCards } from '../mockData';
import { siteConfigAPI } from '../services/api';
import { Award, Layers } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    siteConfigAPI.get().then(setConfig).catch(() => setConfig(null));
  }, []);

  const iconMap = {
    award: Award,
    layers: Layers
  };

  return (
    <div className="relative">
      {/* Hero Background Section */}
      <div 
        className="relative h-[600px] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${heroData.backgroundImage})`
        }}
      >
        <div className="container mx-auto px-4 h-full flex flex-col items-center justify-center text-center">
          <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-bold mb-4 animate-fade-in">
            {config?.hero_title || heroData.title}
          </h1>
          <h2 className="text-yellow-400 text-3xl md:text-4xl lg:text-5xl font-bold mb-6 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            {config?.hero_subtitle || heroData.subtitle}
          </h2>
          <p className="text-white text-lg md:text-xl max-w-3xl animate-fade-in" style={{ animationDelay: '0.4s' }}>
            {config?.hero_description || heroData.description}
          </p>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-black text-white py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-xl md:text-2xl font-semibold mb-6 leading-relaxed">
              If you've achieved something extraordinary or broken a record, it's time to get recognized! 
              The <span className="text-yellow-400 font-bold">Swaarnim Book of Records</span> celebrates remarkable 
              talents and achievements. Don't wait— <span className="text-yellow-400 font-bold">apply now</span> and 
              let your accomplishment be part of history!
            </h3>
            <Button asChild className="bg-red-700 hover:bg-red-800 text-white font-bold px-8 py-6 text-lg rounded transition-all duration-300 hover:scale-110 shadow-lg">
              <Link to="/how-to-apply">Apply Now</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
